import axios from "axios";
import router from "../router/index";
import { Message } from "element-ui";
import moment from "moment/moment";

const event = {
  state: () => ({
    eventMenuKey: +new Date(),
    event: null,
    events: [],
    groups: [],
    tags: [],
    modules: [],
    users: [],
    role: null,
    eventPermission: null,
    whiteLabelSettings: null
  }),
  mutations: {
    setEventMenuKey(state) {
      state.eventMenuKey += 1;
    },
    setWhiteLabelSettings(state, payload) {
      state.whiteLabelSettings = payload;
    },
    setEvent(state, payload) {
      var newForm = payload.item;
      if (newForm.socialMedia.instagram != null) {
        newForm.socialMedia.instagram = newForm.socialMedia.instagram.replaceAll("https://www.instagram.com/", "");
      }
      if (newForm.socialMedia.twitter != null) {
        newForm.socialMedia.twitter = newForm.socialMedia.twitter.replaceAll("https://www.twitter.com/", "");
      }
      if (newForm.socialMedia.linkedIn != null) {
        newForm.socialMedia.linkedIn = newForm.socialMedia.linkedIn.replaceAll("https://www.linkedin.com/", "");
      }
      if (newForm.socialMedia.facebook != null) {
        newForm.socialMedia.facebook = newForm.socialMedia.facebook.replaceAll("https://www.facebook.com/", "");
      }
      if (newForm.socialMedia.youtube != null) {
        newForm.socialMedia.youtube = newForm.socialMedia.youtube.replaceAll("https://www.youtube.com/", "");
      }
      if (newForm.socialMedia.website != null) {
        newForm.socialMedia.website = newForm.socialMedia.website.replaceAll("https://", "");
      }
      if (newForm.endDate != null) {
        newForm.endDate = newForm.endDate.split("T")[0];
      }
      if (newForm.startDate) {
        newForm.startDate = newForm.startDate.split("T")[0];
      }
      state.event = newForm;
      state.modules = payload.modules;
      state.role = payload.role;
    },
    setAuthorizedEvents(state, payload) {
      state.events = payload;
    },
    setEventPermission(state, payload) {
      state.eventPermission = payload;
    }
  },
  actions: {
    async getAuthorizedEvents(context) {
      var res = await axios.post("Event/GetAuthorizedEvents");
      if (!res.data.alert.hasError) {
        context.commit("setAuthorizedEvents", res.data.data.items);
      } else {
        Message.error(res.data.alert.message);
      }
      return res;
    },
    async getEvent(store) {
      var res = await axios.post("event/get");
      store.commit("setEvent", res.data.data);
      if (!res.data.alert.hasError) {
        var overview = await axios.post("/Subscription/Overview");
        if (!overview.data.alert.hasError) {
          var combinedObject = {};
          overview.data.data.currentPlan.values.forEach(item => {
            var key = item.key.replace(/-([a-z])/g, function(match, letter) {
              return letter.toUpperCase();
            });
            key = key.replaceAll("-", "");
            combinedObject[key] = true;

            // Object.keys(item).forEach((key) => {
            //   if (key == "ID" || key == "CreatedDateTime" || key == "UpdatedDateTime" || key == "Title") {
            //     return;
            //   }
            //   const newKey = item.key + `${key.charAt(0).toUpperCase()}${key.slice(1)}`;
            //   combinedObject[newKey] = combinedObject[newKey] || [];
            //   combinedObject[newKey] = item[key];
          });
          store.commit("setEventPermission", combinedObject);
        }
      }
    },
    async updateEventImage(store, payload) {
      var res = await axios.post("event/UpdateImage", { image: payload });
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
        await store.dispatch("getEvent");
      }
    },
    async updateEventLogo(store, payload) {
      var res = await axios.post("event/UpdateLogo", { logo: payload });
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
        await store.dispatch("getEvent");
      }
    },
    async getUsers(store) {
      var res = await axios.post("user/load", { skip: 0, take: 100 });
      store.state.users = res.data.data.items;
    },
    async updateEventBasicInfo(store, payload) {
      // const d = new Date();
      // let diff = d.getTimezoneOffset();
      // if (diff != 0) {
      //     diff = diff * -1;

      //     if (payload.startDate != null) {
      //         payload.startDate = moment(payload.startDate).add(diff, 'minutes');
      //     }

      //     if (payload.endDate != null) {
      //         payload.endDate = moment(payload.endDate).add(diff, 'minutes');
      //     }

      // }
      // payload.Diff = diff;

      var res = await axios.post("Event/UpdateEventBasicInfo", payload);

      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
        await store.dispatch("getEvent");
      }
      return res;
    },
    async updateEventContactInfo(store, payload) {
      var res = await axios.post("Event/UpdateEventContactInfo", payload);
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
        await store.dispatch("getEvent");
      }
      return res;
    },
    async updateEventGeneralSettings(store, payload) {
      var res = await axios.post("Event/UpdateEventGeneralSettings", payload);
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
        await store.dispatch("getEvent");
      }
      return res;
    },
    async updateEventModules(store, payload) {
      var res = await axios.post("Event/updateEventModules", payload);
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
        await store.dispatch("getEvent");
      }
      return res;
    },
    async updateSocialHubSettings(store, payload) {
      var res = await axios.post("/Event/UpdateSocialHubSettings", { socialHub: payload });
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
        store.state.event.socialHub = res.data.data.item;
      }
      return res;
    }
  },
  getters: {
    getEventMenuKey(state) {
      return state.eventMenuKey;
    },
    getEventRole(state) {
      return state.role;
    },
    currentEvent(state) {
      if (state.event == null) {
        return {};
      }
      return state.event;
    },
    getEventPermission(state) {
      return state.eventPermission;
    },
    getEventWhiteLabelSettings(state) {
      return state.whiteLabelSettings;
    }
  }
};
export default event;



// WEBPACK FOOTER //
// ./src/store/event.js